<div class="border border-line rounded-lg p-3 bg-white w-full overflow-x-auto whitespace-nowrap cursor-pointer" (click)="openTokenDetail()">
    <div class="flex-start-center gap-x-2 md:mb-3 text-sm">
        <span nz-icon nzType="antd:v2-notif" class="!text-xl"></span>
        <div>
            <ng-container *ngIf="alertItem.watchlist_type === 'smart_buys'">Smart Holders </ng-container>
            <ng-container *ngIf="alertItem.watchlist_type === 'my_watchlist' || !alertItem.watchlist_type">Watchlist Holders </ng-container>
            <ng-container *ngIf="alertItem.watchlist_type === 'subscribed_watchlist'">{{alertItem.watchlist_name}} </ng-container>
            bought ${{alertItem.buy_amount_usd | kmb2:2}}({{alertItem.buy_amount | kmb2:2}})
            <span class="text-[#2990FF]">{{alertItem.symbol}}</span>
            <ng-container *ngFor="let item of alertItem.star_fields"> 🌟 </ng-container>
        </div>
        <div class="bg-secondaryCard rounded-md px-1 text-xs leading-[26px] h-[26px]">{{lastBuyTimeAge}}</div>
        <div class="h-[26px] rounded-md px-1 text-xs leading-[26px]" [ngClass]="alertItem.watchlist_type">
            <ng-container *ngIf="alertItem.watchlist_type === 'smart_buys'">SocialScan Smart Money</ng-container>
            <ng-container *ngIf="alertItem.watchlist_type === 'my_watchlist'">My Watchlist</ng-container>
            <ng-container *ngIf="alertItem.watchlist_type === 'subscribed_watchlist'">Subscribed Watchlist ({{alertItem.watchlist_name}})</ng-container>
        </div>
    </div>

    <div class="flex-start-center text-xs gap-x-3">
        <div class="flex-start-center column-item md:w-[160px] gap-x-2 md:gap-x-4">
            <div class="relative">
                <nz-avatar [nzSrc]="alertItem.logo" [nzText]="alertItem.symbol | slice:0:2" class="w-8 h-8 min-w-8"></nz-avatar>

                <img *ngIf="alertItem.chain_name === 'base'" src="/assets/imgs/chains/base.png" class="w-4 h-4 absolute -bottom-1 -right-1" alt="" />
                <img *ngIf="alertItem.chain_name === 'bsc'" src="/assets/imgs/chains/bnb.png" class="w-4 h-4 absolute -bottom-1 -right-1" alt="" />
            </div>

            <div class="flex-1 min-w-0">
                <div class="truncate">{{alertItem.symbol}}</div>
                <div class="flex-start-center gap-x-1">
                    <div class="value">{{alertItem.token_address | address}}</div>
                    <span
                        nz-icon
                        nzType="antd:v2-copy"
                        nzTheme="outline"
                        class="cursor-pointer !text-sub-text text-xs hover:!text-black"
                        appCopy
                        [copyText]="alertItem.token_address"
                        (click)="$event.stopPropagation()"
                    ></span>
                </div>
            </div>
        </div>

        <div class="column-item flex-1">
            <div>Buy Timer</div>
            <div class="value">{{buyTimer}}</div>
        </div>

        <div class="column-item flex-1">
            <div>Smart buy</div>
            <div class="value">{{alertItem.smart_money_buy_amount | kmb2:2}}</div>
        </div>

        <div class="column-item flex-1">
            <div>
                MKT Cap
                <ng-container *ngIf="alertItem.star_fields?.includes('market_cap')"> 🌟 </ng-container>
            </div>
            <div class="value">${{alertItem.market_cap | kmb2:2}}</div>
        </div>

        <div class="column-item flex-1">
            <div>
                Liquidity
                <ng-container *ngIf="alertItem.star_fields?.includes('liquidity')"> 🌟 </ng-container>
            </div>
            <div class="value">${{alertItem.dex_liquidity | kmb2:2}}</div>
        </div>

        <div class="column-item flex-[2]">
            <div>
                Smart Holders/Total Holders
                <ng-container *ngIf="alertItem.star_fields?.includes('holders')"> 🌟 </ng-container>
            </div>
            <div class="value">{{alertItem.smart_money_holder_count | kmb2:2}}/{{alertItem.total_holders_count | kmb2:2}}</div>
        </div>

        <div class="column-item flex-[2]">
            <div>
                24h Smart TXs/Total TXs Volume
                <ng-container *ngIf="alertItem.star_fields?.includes('tx_volume_24h')"> 🌟 </ng-container>
            </div>
            <div class="value">{{alertItem.swap_count_1d | kmb2:2}}/{{alertItem.swap_amount_usd_1d | kmb2:2}}</div>
        </div>

        <div class="column-item flex-1">
            <div>
                Top 10 Holders
                <ng-container *ngIf="alertItem.star_fields?.includes('top_10_holders_percentage')"> 🌟 </ng-container>
            </div>
            <div class="value">{{alertItem.top_10_holders_percentage ? (alertItem.top_10_holders_percentage | percent:'1.0-2') : '-' }}</div>
        </div>
    </div>
</div>
